import { render, staticRenderFns } from "./OrganizationTypeList.vue?vue&type=template&id=0925ba80&scoped=true&"
import script from "./OrganizationTypeList.vue?vue&type=script&lang=js&"
export * from "./OrganizationTypeList.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationTypeList.vue?vue&type=style&index=0&id=0925ba80&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0925ba80",
  null
  
)

export default component.exports